<script>
export default {
  name: 'HelpRequestedNotification',
};
</script>

<template lang="pug">

transition(enter-active-class="animated fadeInUp", leave-active-class="animated fadeOutDown")
  p.notification.bg-black-overlay.pa2.fw6.f7.white.tc
    icon.mr2.w1.fill-green.v-mid(name="checkmark")
    | {{ $t('Help is on the way!') }}

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.helprequested {

}
</style>
